import React from 'react';
import {
  TextField,
  InputAdornment
} from '@mui/material';
import {
  Search as SearchIcon
} from '@mui/icons-material';

const BookingSearch = ({ searchTerm, onSearchChange }) => {
  return (
    <TextField
      fullWidth
      placeholder="Rechercher par nom, email, téléphone ou service..."
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'grey.500' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        mb: 2,
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
          bgcolor: 'white',
          py: { xs: 0.5, sm: 1 },
          '& fieldset': {
            borderColor: 'grey.300',
          },
          '&:hover fieldset': {
            borderColor: 'grey.400',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: { xs: '0.875rem', sm: '1rem' },
          py: { xs: 1, sm: 1.5 }
        }
      }}
    />
  );
};

export default BookingSearch;